var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { WorkspaceMenuContents, WorkspaceMenuShell } from './components';
export const WorkspaceMenu = ({ isLeaveWorkspaceDisallowed, setIsMenuOpen, triggerTestId, workspace, }) => (_jsx(WorkspaceMenuShell, { menuContents: _jsx(WorkspaceMenuContents, { isLeaveWorkspaceDisallowed: isLeaveWorkspaceDisallowed, workspace: workspace }), ...(setIsMenuOpen && { setIsMenuOpen }), triggerTestId: triggerTestId, workspaceId: workspace.id }));
_react_refresh_temp_1 = WorkspaceMenu;
$RefreshReg$(_react_refresh_temp_1, "WorkspaceMenu");
